import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import SearchInput from './search-input';

const Search = () => {
  const t = useTranslations();

  return (
    <div className="relative  flex items-center justify-center overflow-hidden sm:justify-around">
      <div>
        <Image
          alt="Course page first hero image"
          title="Kurs sahifasining rasmi"
          width={157}
          height={173}
          className="min-w-39 min-w-43"
          src="/images/course-first-hero.webp"
        />
      </div>
      <div className="z-10 flex max-w-sm flex-col items-center justify-center">
        <h1 className="text-xl font-semibold">{t('mashxur_oqtuvchilar_kurslari')}</h1>
        <p className="my-3 text-center text-xs">{t('mashxur_oqtuvchilar_kurslari_desc')}</p>
        <SearchInput />
      </div>
      <div>
        <Image
          alt="Course page second hero image"
          title="Kurs sahifasining rasmi"
          width={157}
          height={173}
          className="min-w-39 min-w-43"
          src="/images/course-second-hero.webp"
        />
      </div>
    </div>
  );
};

export default Search;
